<template>
    <div>
        <div v-if="users">
            <table class="table table-hover">
                <tbody>
                <template v-if="selectAll && users && users.length">
                  <tr>
                    <td><input @change="updateSelect" type="checkbox" v-model="selectAllCheckbox" :id="`ch_all`"></td>
                    <td><strong><label class="pointer" :for="`ch_all`">Выбрать всех курьеров</label></strong></td>
                  </tr>
                </template>
                <template v-if="type == 'wPacks'">
                  <tr class="pointer" v-scroll-to="{ el: '#id-'+runner.id, offset: -80 }" v-for="(runner, index) in this.users" :key="index">
                    <td></td>
                    <td><label :for="`ch_${runner.id}`">{{ runner.name }}</label></td>
                  </tr>
                </template>
                <template v-else>
                  <tr v-for="(runner, index) in this.users" :key="index">
                    <td><input type="checkbox" v-model="selected_runners[runner.id]" :id="`ch_${runner.id}`"></td>
                    <td><label class="pointer" :for="`ch_${runner.id}`">{{ runner.name }}</label></td>
                  </tr>
                </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

    import api from '@/api'

    export default {
      components: {},
      data() {
        return {
          selectAllCheckbox: false,
          selected_runners: {}
        }
      },
      mounted() {
        this.users.forEach(u => this.selected_runners[u.id] = false);
      },
      props: [
        'users', 'type', 'selectAll'
      ],
      methods: {
        updateSelect() {
          if (!this.selectAllCheckbox) {
            this.selected_runners = {};
          } else {
            this.selected_runners = this.users.reduce((acc, u) => {
              acc[u.id] = true;
              return acc;
            }, {});
          }
        }
      }
    }

</script>

<style scoped>
    table.table td {
        padding: 2px;
    }

    .pointer {
        cursor: pointer;
    }
</style>
